module.exports = __webpack_public_path__ + "6f59a00860233984e06a5f4aac74c812.jpg";